import {
  lgBumps,
  MainSection,
  NotificationContainer,
  pageEntranceSpringValues,
  SideSection,
  StickySidebar,
  WideContainer,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { animated, useSpring } from 'react-spring'

import { getPolicyVersion } from '../../../../../../domain'
import { RenewalBanner } from '../../../../../homePage/organisms/RenewalBanner'
import {
  PolicyAddOnSection,
  PolicyAutoRenewalSection,
  PolicyCoverSection,
  PolicyDetailsView,
  PolicyExcessSection,
} from '../../../../../organisms/policy'
import { ProductFaqSection } from '../../../../../organisms/product'
import { PolicyPromotionBanner } from '../../../../../organisms/promotion'
import { usePolicy } from '../../../PolicyProvider'
import { PolicySidebar } from '../../PolicySidebar'
import { PolicyCancellationNotification } from '../components/PolicyCancellationNotification'

export const PolicyDetailsTab: FunctionComponent = () => {
  const { policy } = usePolicy()
  const { quote } = getPolicyVersion(policy)

  const spring = useSpring(pageEntranceSpringValues)

  return (
    <animated.div style={spring}>
      <WideContainer>
        <NotificationContainer mb={xlBumps}>
          <RenewalBanner type='standalone' />
          <PolicyCancellationNotification policy={policy} />
          <PolicyPromotionBanner />
        </NotificationContainer>
      </WideContainer>
      <WideContainer variant='sidebar'>
        <StickySidebar variant='offset'>
          <SideSection>
            <PolicySidebar key='desktop' />
          </SideSection>
        </StickySidebar>
        <MainSection>
          <PolicySidebar key='mobile' displayOn='mobile' mb={lgBumps} />
          <PolicyDetailsView mb={xlBumps} />
          <PolicyAutoRenewalSection policy={policy} mb={xlBumps} />
          <PolicyCoverSection mb={xlBumps} />
          <PolicyAddOnSection policy={policy} quote={quote} mb={xlBumps} />
          <PolicyExcessSection mb={xlBumps} />
          <ProductFaqSection />
        </MainSection>
      </WideContainer>
    </animated.div>
  )
}
